import { useTheme } from './ThemeContext';
import { getTokens } from './tokens';

const hexToRgb = (hex) => {
  const h = hex.replace('#', '');
  const n = parseInt(h.length === 3 ? h.split('').map((c) => c + c).join('') : h, 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
};

export const getCanvasColors = (mode) => {
  const t = getTokens(mode);
  const [ir, ig, ib] = hexToRgb(t.inkPrimary);
  const [sr, sg, sb] = hexToRgb(t.surfaceRaised);
  return {
    labelColor: t.inkPrimary,
    labelBg: `rgba(${sr}, ${sg}, ${sb}, 0.88)`,
    labelBorder: `rgba(${ir}, ${ig}, ${ib}, 0.35)`,
    edgeColor: mode === 'dark' ? '#64748b' : '#52525b',
    edgeAlphaHex: mode === 'dark' ? '66' : '99',
    nodeStroke: mode === 'dark' ? '#ffffff' : t.surfaceRaised,
    pulseRing: (alpha) => `rgba(${ir}, ${ig}, ${ib}, ${alpha})`,
    tooltipBg: mode === 'dark' ? 'rgba(30, 30, 27, 0.92)' : 'rgba(232, 228, 220, 0.94)',
    tooltipText: t.inkPrimary,
    tooltipTextSecondary: t.inkSecondary,
    tooltipTextAccent: t.accentText,
    tooltipBorder: t.borderSubtle,
    panelBg: mode === 'dark' ? 'rgba(22, 22, 20, 0.9)' : 'rgba(247, 245, 241, 0.92)',
    panelBorder: t.borderSubtle,
  };
};

export const useCanvasColors = () => {
  const { theme } = useTheme();
  return getCanvasColors(theme);
};
